module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Revote | Planning poker for remote teams","short_name":"Revote","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/icon-logo.svg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"da4768ae6f65ee975b097b3e66d2e207"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
